// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { LOGIN_CONFIG, GESTION_CONFIG, ADMIN_CONFIG } from './environment.config';

const URL_MS_BASE = 'https://iacg-timepro-qa-be.yellowhill-a257ca35.northcentralus.azurecontainerapps.io';

export const environment = {
  production: true,
  login_conf: LOGIN_CONFIG,
  gestion_confg: GESTION_CONFIG,
  admin_conf: ADMIN_CONFIG,
  url_ms_base: URL_MS_BASE
};

